import { render, staticRenderFns } from "./DataContributorOnboardingStep1.vue?vue&type=template&id=52ce4df9&scoped=true"
import script from "./DataContributorOnboardingStep1.vue?vue&type=script&lang=js"
export * from "./DataContributorOnboardingStep1.vue?vue&type=script&lang=js"
import style0 from "./DataContributorOnboardingStep1.vue?vue&type=style&index=0&id=52ce4df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce4df9",
  null
  
)

export default component.exports